import { ts } from '_core';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.UNIVERSE_TURNOVER,
    form: false,
    title: 'Universe Turnover',
    neededFiles: ['universe_turnover'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.UNIVERSE],
    helpLabel: 'universe_turnover',
  },
] satisfies ts.types.analysis.WidgetConfig[];
